import React, { createContext, useContext, useState, useEffect } from "react";
import localforage from "localforage";

export type ClinicUserFields = {
    clinic_id: string | null;
    clinic_name: any | null;
    fname: any | null;
    lname: any | null;
    institution_id: any | null;
    staff_id: any | null;
    token: any | null;
};

export const ClinicUserContext = createContext<ClinicUserFields | null>(null);

export const ClinicUserProvider: React.FC<{children: React.ReactNode}> =  ({ children }) => {
    const [userData, setUserData] = useState<ClinicUserFields>({
        clinic_id: null,
        clinic_name: null,
        fname: null,
        lname: null,
        institution_id: null,
        staff_id: null,
        token: null
    });

    useEffect(() => {
        const userInfo = async () => {
            try {
                let clinic_id = "";
                let clinic_name= "";
                let fname = "";
                let lname = "";
                let institution_id = "";
                let staff_id = "";
                let token = "";

                await localforage.getItem("clinic_id").then((cli: any)=> { clinic_id = cli });
                await localforage.getItem("clinic_name").then((clin: any)=> { clinic_name = clin });
                await localforage.getItem("fname").then((fnm: any)=> { fname = fnm });
                await localforage.getItem("lname").then((lnm: any)=> { lname = lnm });
                await localforage.getItem("institution_id").then((inst: any)=> { institution_id = inst });
                await localforage.getItem("staff_id").then((stf: any)=> { staff_id = stf });
                await localforage.getItem("token").then((tok: any)=> { token = tok });

                setUserData({ clinic_id, clinic_name, fname, lname, institution_id, staff_id, token });
            } catch (error) {
                console.error("Failed to fetch data from localforage:", error);
            }
        };
        userInfo();
    }, []);

    return (
        <ClinicUserContext.Provider value={userData}>
            {children}
        </ClinicUserContext.Provider>
    );
};

export const useClinicUserData = () => {
    const context = useContext(ClinicUserContext);
    if (!context) {
        throw new Error("useClinicUserData must be used within a ClinicUserProvider");
    }
    return context;
}; 